import React, { useEffect } from "react";
import STD from "../../components/Std";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import * as modalActions from "../../redux/actions/modalActions";
import * as notificationActions from "../../redux/actions/notificationAction";
import { setLanguage } from "redux-i18n";
import * as commonActions from "../../redux/actions/commonAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { useLocation } from "react-router-dom";
import * as userAuthActions from "../../redux/actions/userAuthAction";

const Std = (props, context) => {
  const stdReducer = useSelector((state) => state.stdReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const notificationReducer = useSelector((state) => state.notification);


  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const notificationAction = bindActionCreators(notificationActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);

  const commonAction = bindActionCreators(commonActions, dispatch);

  let urllocation = useLocation();

  // Call required apis for dropdown after first render
  useEffect(() => {
    stdAction.prepareStdConfigData(profileReducer.managersDetails.companyId);
  }, []);


  //set max count
  const setMaximumFormStep = (maxCount) => {
    stdAction.setMaximumFormStep(maxCount);
  };

  //set minimum count
  const setMinimumFormStep = (minCount) => {
    stdAction.setMinimumFormStep(minCount);
  };

  //set current form step
  const setCurrentFormStep = (stepCount) => {
    stdAction.setCurrentFormStep(stepCount);
  };


  const setIsSearch = (isSearch) => {
    stdAction.setIsSearch(isSearch);
  };

  //get client info by ein or clientId
  const getClientInfoByIdOrEin = (ein, clientId) => {
    stdAction.getClientInfoById(ein, clientId);
  };

  //set client info by clientId or ein
  const setClientInfoByIdOrEin = (data) => {
    stdAction.setClientInfoByIdOrEin(data);
  };

  //for open modal
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  //for closing modal
  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const uploadFiles = (file, allFiles, props) => {
    stdAction.uploadFiles(file, allFiles, props);
  };

  //calling remove file api
  const removeFiles = (filePath, isDocs, index, allAttachments) => {
    stdAction.removeFiles(filePath, isDocs, index, allAttachments);
  };

  //reset application
  const resetErsApplicationUrl = () => {
    stdAction.resetErsApplicationUrl();
  };

  //add std statement
  const addstdemployeestatement = (stdData) => {
    stdAction.addstdemployeestatement(stdData, profileReducer.managersDetails.managerId);
  };

  //add new job title
  const addNewJobTitle = (jobDetail, locationID) => {
    commonAction.addNewJobTitle(jobDetail, locationID);
  };

  //add new manager
  const addNewManager = (managerDetails) => {
    commonAction.addNewManager(managerDetails);
  };

  //get job by locationId
  const getJob = (locationID) => {
    commonAction.getJob(locationID);
  };

  //set attachment
  const setAttachment = (attachment) => {
    stdAction.setAttachment(attachment);
  };

  //set jobDetails
  const setJob = (jobDetails) => {
    commonAction.setJob(jobDetails);
  };


  const resetIsAdded = (isAdded) => {
    stdAction.resetIsAdded(isAdded);
  };

  //show alert error
  const showAlertError = (labelKey, message) => {
    stdAction.showAlertError(labelKey, message);
  };

  //for changing language
  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };


  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  //get all pending application
  const getAllPendingApplications = (managerId) => {
    notificationAction.getAllPendingApplications(managerId);
  }

  //reset Std reducer
  const resetSTDReducer = () => {
    stdAction.resetState();
  }

  const setOnSubmit = (isOnSubmit) => {
    notificationAction.setOnSubmit(isOnSubmit);
  }

  const resetSuccessMessage = (message) => {
    commonAction.setSuccessMessage(message);
  }

  const resetsuccessMessageForBackupUserAssigned = () => userAuthAction.resetsuccessMessageForBackupUserAssigned();

  const resetStdEmployeeStatement = () => stdAction.resetStdEmployeeStatement();

  //get all country province
  const getStates = (contryId) => {
    stdAction.getState(contryId);
  }

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.STD_FORM} permission={PERMISSION_TYPE.VIEW}>
          <STD
            urlLocation={urllocation}
            addNewManager={addNewManager}
            addNewJobTitle={addNewJobTitle}
            isAdded={stdReducer.isAdded}
            resetIsAdded={resetIsAdded}
            removeFiles={removeFiles}
            uploadFiles={uploadFiles}
            addstdemployeestatement={addstdemployeestatement}
            openSetModalAction={openSetModal}
            closeRemoveModal={closeRemoveModal}
            stepCount={stdReducer.step}
            maxStep={stdReducer.maxSteps}
            minStep={stdReducer.minSteps}
            city={stdReducer.city}
            country={stdReducer.country}
            supervisorList={stdReducer.supervisorList}
            planLink={stdReducer.planLink}
            state={stdReducer.state}
            attachment={stdReducer.attachment}
            job={commonReducer.job}
            getJob={getJob}
            setJob={setJob}
            employmentStatus={stdReducer.employmentStatus}
            prefferedLanguage={stdReducer.prefferedLanguage}
            setMaxStep={setMaximumFormStep}
            setMinStep={setMinimumFormStep}
            setCurrentFormStep={setCurrentFormStep}
            isSearch={stdReducer.isSearch}
            setIsSearch={setIsSearch}
            region={stdReducer.region}
            ersFormPdfLink={stdReducer.ersFormPdfLink}
            resetErsApplicationUrl={resetErsApplicationUrl}
            department={stdReducer.department}
            location={stdReducer.location}
            clientInfo={stdReducer.clientInfo}
            managersDetails={profileReducer.managersDetails}
            getClientInfoByIdOrEin={getClientInfoByIdOrEin}
            clientInfoById={stdReducer.clientInfoById}
            setClientInfoByIdOrEin={setClientInfoByIdOrEin}
            showAlertError={showAlertError}
            context={context}
            i18nReducerLang={i18nReducer.lang}
            setAttachment={setAttachment}
            getAllPendingApplications={getAllPendingApplications}
            allPendingApplications={notificationReducer.allPendingApplications}
            resetSTDReducer={resetSTDReducer}
            contiuedPendingApplicationObj={stdReducer.stdEmployeeStatement}
            resetContiuedPendingApplicationObj={resetStdEmployeeStatement}
            setOnSubmit={setOnSubmit}
            notificationReducer={notificationReducer}
            profileReducer={profileReducer}
            resetSuccessMessage={resetSuccessMessage}
            commonReducer={commonReducer}
            resetsuccessMessageForBackupUserAssigned={resetsuccessMessageForBackupUserAssigned}
            getStates={getStates}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

Std.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default Std;
